import styled from '@emotion/styled'
export const StyleInputWrapper = styled.div<any>`
  position: relative;
`
export const StyleInput = styled.input<any>`
  width: 100%;
  border-radius: 6px;
  height: 40px;
  text-indent: ${(props) =>
    props?.hasIcon && props?.side == 'left' ? '35px' : '10px'};
  padding: 0px;
  border: 1px solid
    ${(props) =>
      props.isFocus
        ? props.theme.colors.primary
        : props?.hasError
          ? props.theme.colors.danger
          : props.theme.colors.inputBorder};
  outline: none;
  font-size: 14px;
  &::placeholder {
    font-size: 12px;
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Poppins;
  }
  &:disabled {
    background-color: ${(props) => props.theme.colors.white};
    cursor: not-allowed;
  }

  ${(props) => props.hasIcon && props?.side == 'right' && `padding-left: 35px;`}
  ${(props) => props.styleInput}
`

export const StyleIconWrapper = styled.div<any>`
  position: absolute;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => {
    if (props.side == 'right') {
      return `right: 0px;`
    } else {
      return `left: 0px;`
    }
  }}
`
